export default __webpack_public_path__ + "static/logo_tena-47d17b551738b08bc5694ee98ea393e7.webp";